import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import api_mediator from "@/utils/api_mediator";
import { getToken as getAuthToken } from "@/utils/auth";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  enterpriseName: "",
  enterpriseId: "",
  uniqueId: "",
  leftServeDayStr: "",
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_ENTERPRISE_NAME: (state, enterpriseName) => {
    state.enterpriseName = enterpriseName;
  },
  SET_ENTERPRISE_ID: (state, enterpriseId) => {
    state.enterpriseId = enterpriseId;
  },
  SET_LEFT_SERVE_DAY_STR: (state, leftServeDayStr) => {
    state.leftServeDayStr = leftServeDayStr;
  },
  SET_UNIQUE_ID: (state, uniqueId) => {
    state.uniqueId = uniqueId;
  },
};

const actions = {
  // user login
  login({ commit, state }, Token) {
    return new Promise((resolve, reject) => {
      commit("SET_TOKEN", Token);
      setToken(Token);
      resolve();
    });
  },

  // get user info
  async getInfo({ commit, state }) {
    const { data } = await api_mediator().enterprise.GetUserInfo();
    const dataInfo = {
      roles: data.roles,
      name: data.userName,
      avatar: data.avatar,
      introduction: "I am a super administrator",
      enterpriseName: data.enterpriseName,
      enterpriseId: data.enterpriseId,
      uniqueId: data.uniqueId,
      leftServeDayStr: data.leftServeDayStr,
    };
    return new Promise((resolve, reject) => {
      commit("SET_ROLES", dataInfo.roles);
      commit("SET_NAME", dataInfo.name);
      commit("SET_AVATAR", dataInfo.avatar);
      commit("SET_INTRODUCTION", dataInfo.introduction);
      commit("SET_ENTERPRISE_NAME", dataInfo.enterpriseName);
      commit("SET_ENTERPRISE_ID", dataInfo.enterpriseId);
      commit("SET_LEFT_SERVE_DAY_STR", dataInfo.leftServeDayStr);
      commit("SET_UNIQUE_ID", dataInfo.uniqueId);

      resolve(dataInfo);
      // getInfo(state.token)
      //   .then((response) => {
      //     const { data } = response;
      //     if (!data) {
      //       reject("Verification failed, please Login again.");
      //     }
      //     const { roles, name, avatar, introduction } = data;
      //     // roles must be a non-empty array
      //     if (!roles || roles.length <= 0) {
      //       reject("getInfo: roles must be a non-null array!");
      //     }
      //     commit("SET_ROLES", roles);
      //     commit("SET_NAME", name);
      //     commit("SET_AVATAR", avatar);
      //     commit("SET_INTRODUCTION", introduction);
      //     resolve(data);
      //   })
      //   .catch((error) => {
      //     reject(error);
      //   });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      commit("SET_NAME", "");
      commit("SET_AVATAR", "");
      commit("SET_INTRODUCTION", "");
      commit("SET_ENTERPRISE_NAME", "");
      commit("SET_ENTERPRISE_ID", "");
      commit("SET_LEFT_SERVE_DAY_STR", "");
      commit("SET_UNIQUE_ID", "");
      removeToken();
      resetRouter();

      dispatch("tagsView/delAllViews", null, { root: true });

      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLES", []);
      commit("SET_NAME", "");
      commit("SET_AVATAR", "");
      commit("SET_INTRODUCTION", "");
      commit("SET_ENTERPRISE_NAME", "");
      commit("SET_ENTERPRISE_ID", "");
      commit("SET_LEFT_SERVE_DAY_STR", "");
      commit("SET_UNIQUE_ID", "");
      removeToken();
      resolve();
    });
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + "-token";

    commit("SET_TOKEN", token);
    setToken(token);

    const { roles } = await dispatch("getInfo");

    resetRouter();

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch("permission/generateRoutes", roles, {
      root: true,
    });
    // dynamically add accessible routes
    router.addRoutes(accessRoutes);

    // reset visited views and cached views
    dispatch("tagsView/delAllViews", null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
